import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../admin/AdminSidebar";
import { FaBars } from "react-icons/fa";

function AdminLayout(props) {
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // if (!localStorage.getItem("land-trandes-access-token")) {
    //   navigate("/admin/login");
    // }
  }, [navigate, collapsed]);

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  
  return (
    <div className={`app ${toggled ? "toggled" : ""} bg-zinc-100`}>
      <AdminSidebar
        collapsed={collapsed}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
        handleCollapsedChange={handleCollapsedChange}
      />
      <main className="bg-white">
        <div className="p-2 min-h-[50px] lg:min-h-[70px] flex items-center bg-[#f5f7f9] lg:bg-transparent">
          <FaBars
            className="btn-toggle"
            onClick={() => handleToggleSidebar(true)}
          />
        </div>
        {props.children}
      </main>
    </div>
  );
}

export default AdminLayout;
